import styled from 'styled-components';
import Button from '../Button';
import { IPrimaryButtonProps } from '../../../../types/buttonTypes';

const PrimaryButtonWrapper = styled(Button)<IPrimaryButtonProps>`
  background-color: ${({ bgColor, theme }) => (bgColor ? `var(--base-color-${bgColor})` : theme?.colors?.primary)};
  border-color: ${({ bgColor, theme }) => (bgColor ? `var(--base-color-${bgColor})` : theme?.colors?.primary)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export default PrimaryButtonWrapper;

export const AriaDescription = styled.span`
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
